










































































































































































































































import moment from 'moment';
import * as R from 'ramda';
import Vue from 'vue';

import { listTask, Project, Task } from './graphql';

import CalendarInput from './Calendar.vue';
import JobView from '@/vue/components/JobView/index.vue';
import {Job} from '@/core/entity';

interface Auditor {
  id: string;
  name: string;
  tasks: Task[];
}

export default Vue.extend({
  components: {
    'input-calendar': CalendarInput,
    'view-job': JobView,
  },

  apollo: {
    tasks: {
      query: listTask,
      variables() {
        const date = this.date.format('YYYY-MM-DD');
        return { date };
      },
    },
  },

  data() {
    const jobId = this.$route.params.job_id;
    return {
      isDrawerVisible: !!jobId,
      date: moment(),
      tasks: null as Task[] | null,
    };
  },

  watch: {
    jobId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  computed: {
    jobId(): string {
      return this.$route.params.job_id;
    },

    auditors(): Auditor[] {
      if (this.tasks === null) {
        return [];
      }

      return R.pipe(
        R.groupBy<Task>((r) => (r.auditor ? r.auditor.id : 'Unassigned')),
        R.values,
        R.map<Task[], Auditor>((tasks) => {
          const f = R.head(tasks)!;

          return {
            id: f.auditor ? f.auditor.id : 'unassigned',
            name: f.auditor ? f.auditor.name : 'Unassigned',
            tasks,
          };
        }),
        R.sortWith([R.ascend(R.prop('name'))]),
      )(this.tasks!);
    },

    auditorCount(): number {
      if (this.tasks === null) {
        return 0;
      }

      return R.pipe(
        R.reject<Task, 'array'>(R.propEq('auditor', null)),
        R.map<Task, string>((t) => t.auditor.id),
        R.uniq,
        R.length,
      )(this.tasks!);
    },

    entryCount(): number {
      if (this.tasks === null) {
        return 0;
      }

      return R.pipe(
        R.map<Task, number>((t) => t.entries.length),
        R.sum,
      )(this.tasks!);
    },

    outletCount(): number {
      if (this.tasks === null) {
        return 0;
      }

      return R.pipe(
        R.map<Task, string>((t) => t.outlet.id),
        R.uniq,
        R.length,
      )(this.tasks!);
    },

    projects(): Project[] {
      if (this.tasks === null) {
        return [];
      }

      return R.pipe(
        R.map<Task, Project[]>((t) => t.projects),
        // @ts-ignore Typescript issue with R.flatten
        R.flatten,
        R.uniqBy<Project, string>((p) => p.id),
      )(this.tasks!);
    },

    jobs(): Job[] {
      if (this.tasks === null) {
        return [];
      }

      return R.pipe(
          R.map<Task, Job[]>((t) => t.jobs),
          // @ts-ignore Typescript issue with R.flatten
          R.flatten,
          R.uniqBy<Job, string>((j) => j.id),
      )(this.tasks!);
    },

    selectedDate(): string {
      return this.date.format('D MMMM YYYY');
    },
  },

  filters: {
    as_entry_sum(tasks: Task[]) {
      return R.pipe(
        R.map<Task, number>((t) => t.entries.length),
        R.sum,
      )(tasks);
    },
  },

  methods: {
    onSelectDate(date: moment.Moment) {
      this.date = date;
    },
    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.jobId) {
        this.$router.back();
      }
    },

    showDrawer() {
      this.isDrawerVisible = true;
    },
  },
});
